module.exports = __webpack_public_path__ + "img/cigna-logo.fc00a1e6.svg";